import React from "react";
import Highcharts, { Chart } from "highcharts";

Highcharts.SVGRenderer.prototype.symbols.plus = function(x, y, w, h) {
  return [
    "M",
    x,
    y + h / 2,
    "L",
    x + w,
    y + h / 2,
    "M",
    x + w / 2,
    y,
    "L",
    x + w / 2,
    y + h,
    "z"
  ];
};

export default class Highchart extends React.Component {
  componentDidMount() {
    this.chart = new Chart(this.props.containerId, this.props.options);
  }

  componentWillUnmount() {
    this.chart.destroy();
  }

  render() {
    const { width, height } = this.props;
    return <div style={{ width, height }} id={this.props.containerId} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Highchart.js